'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = areThereDifferences;

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areThereDifferences() {
    var currentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fieldsToCompare = arguments[2];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(fieldsToCompare), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var field = _step.value;

            if (field === 'children') {
                if (currentProps[field] !== nextProps[field]) return true;
            }
            var type = (0, _typeof3.default)(currentProps[field]);
            if (type === 'object') {
                if (!(0, _isEqual2.default)(currentProps[field], nextProps[field])) return true;
            } else if (type !== 'function') {
                if (currentProps[field] !== nextProps[field]) {
                    return true;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return false;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/propsComparer.js
// module id = wsGv
// module chunks = 46